/**
 * Centralized Error Messages for Validation
 *
 * Single source of truth for all validation error messages.
 * Provides consistency, i18n readiness, and easy maintenance.
 *
 * @module validation/messages
 */

export const VALIDATION_MESSAGES = {
  required: "Este campo é obrigatório",

  email: {
    invalid: "Formato de e-mail inválido",
    required: "E-mail é obrigatório",
  },

  password: {
    required: "Senha é obrigatória",
    tooShort: "Senha deve ter pelo menos 6 caracteres",
    needsUppercase: "Senha deve conter pelo menos uma letra maiúscula",
    needsLowercase: "Senha deve conter pelo menos uma letra minúscula",
    needsNumber: "Senha deve conter pelo menos um número",
    match: "As senhas devem ser iguais",
  },

  name: {
    tooShort: "Nome deve ter pelo menos 3 caracteres",
    tooLong: "Nome deve ter no máximo 100 caracteres",
    required: "Nome é obrigatório",
  },

  currency: {
    negative: "Valor não pode ser negativo",
    invalid: "Valor inválido",
    precision: "Valor deve ter no máximo 2 casas decimais",
    required: "Valor é obrigatório",
  },

  date: {
    invalid: "Data inválida (formato: YYYY-MM-DD)",
    required: "Data é obrigatória",
    future: "Data não pode estar no futuro",
    past: "Data não pode estar no passado",
    range: "Data final deve ser posterior à data inicial",
  },

  document: {
    cpfInvalid: "CPF inválido",
    cnpjInvalid: "CNPJ inválido",
    formatInvalid: "Formato de documento inválido",
    typeRequired: "Tipo de documento é obrigatório",
    required: "Documento é obrigatório",
  },

  phone: {
    invalid: "Formato de telefone inválido",
    tooShort: "Telefone deve ter pelo menos 10 dígitos",
    tooLong: "Telefone deve ter no máximo 11 dígitos",
    required: "Telefone é obrigatório",
  },

  cep: {
    invalid: "CEP inválido (formato: XXXXX-XXX ou XXXXXXXX)",
    required: "CEP é obrigatório",
  },

  bankAccount: {
    typeInvalid: "Tipo de conta inválido (corrente ou poupança)",
    numberInvalid: "Número da conta inválido",
    required: "Conta bancária é obrigatória",
  },

  generic: {
    tooShort: (min: number) => `Deve ter pelo menos ${min} caracteres`,
    tooLong: (max: number) => `Deve ter no máximo ${max} caracteres`,
    between: (min: number, max: number) => `Deve ter entre ${min} e ${max} caracteres`,
    minValue: (min: number) => `Valor mínimo: ${min}`,
    maxValue: (max: number) => `Valor máximo: ${max}`,
  },
} as const;

export type ValidationMessages = typeof VALIDATION_MESSAGES;
